import { Layout } from "../../graph"

/**
 * Creates a new Layout instance and merges layout data with all nodes and edges.
 * Layout data produced from `Layout` provides all positioning information like:
 *  - X,Y coordinates of node elements
 *  - X,Y coordinates off all points needed to draw each edge
 *
 * @param data {object} { roots: [JSON], nodes: [JSON], edges: [JSON], scope: HTMLElement, layout: Object  }
 * @return {object} { roots: [JSON], nodes: [JSON], edges: [JSON], scope: HTMLElement, layout: Layout  }
 */
const layoutGraph = data => {
  const layout = new Layout(data.nodes, data.edges, data.layout)

  layout.layout()

  const nodes = layout.graph.nodes().map(node => {
    return {
      ...layout.graph.node(node)
    }
  })

  const edges = layout.graph.edges().map(edge => {
    return {
      ...edge,
      ...layout.graph.edge(edge)
    }
  })

  return {
    ...data,
    edges: edges,
    nodes: nodes,
    layout: layout
  }
}

export default layoutGraph
